import { useFileFormMixin } from "../../../../javascript/shared/assetHelpers";
import { dispatchCustomEvent } from "../../../../javascript/shared/helpers"
import AssetsFormRowController from "./assets-form-row-controller";

export default class extends AssetsFormRowController {
  connect() {
    useFileFormMixin(this)
    super.connect()
    App.Helpers.addAjaxBeforeHandler(this.formTarget, this.cancelSubmitIfFileNotUploaded.bind(this))
    App.Helpers.listenToCustomEvent(document, "asset--file-exchange", this.setFileFieldFiles.bind(this))
    addEventListener("direct-upload:start", this.initializePendingUploadHandler.bind(this))
    addEventListener("direct-upload:end", this.markFileUploadAsComplete.bind(this)) // if the progress has started, the first submission should be past
  }

  cancel(event) {
    event && event.preventDefault()
    this.element.remove()
  }

  cancelSubmitIfFileNotUploaded() {
    return this.assetType == "file" && !this.fileUploadComplete ? false : true
  }

  initializePendingUploadHandler(event) {
    const { id, file } = event.detail
    if (file === this.file) {
      dispatchCustomEvent("direct-upload:pending", this.element, { fileID: id, formID: this.uploadID })
      this.uploadID = id
    }
  }

  markFileUploadAsComplete(event) {
    const { id } = event.detail
    if (id == this.uploadID) {
      this.fileUploadComplete = true
    }
  }

  get assetType() {
    return this.data.get("asset-type")
  }
}



// WEBPACK FOOTER //
// ./app/components/assets/assets/javascript/assets-new-form-row-controller.js